/**
 * BEVO-119 — Estado de la caja de PDV Web.
 *
 * La caja abierta/cerrada vive en localStorage `cashBox_${shopCode}` (lo
 * escribe BoxPos.vue). La caja está abierta si existe y el último registro no
 * tiene `closeBox: true`. Lo usan PdvMain (al entrar) y payCommons (al cobrar).
 */
export const CASHBOX_CLOSED_MESSAGE = "Debes abrir la caja para poder operar.";

export const isCashboxOpen = (shopCode) => {
  const dataBox = localStorage.getItem(`cashBox_${shopCode}`);
  if (!dataBox) return false;
  try {
    return JSON.parse(dataBox)?.[0]?.closeBox !== true;
  } catch (error) {
    return false;
  }
};
